/**
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
*/

import { RouterModule, Routes } from '@angular/router';

import { CanDeactivateViaEditGuardService } from './../core/services/can-deactivate-via-edit-guard.service';
import { NgModule } from '@angular/core';
import { YardLocalComponent } from './yard-local.component';
import { YardLocalDataComponent } from './data/yard-local-data.component';
import { YardLocalResolver } from './shared/yard-local.resolver';

const yardLocalRoutes: Routes = [
    {
        path: 'yard-local',
        component: YardLocalComponent,
        data: { tab: 'Yard-Local' },
        children: [
            {
                path: 'data',
                component: YardLocalDataComponent,
                data: { tab: 'Yard-Local' },
                resolve: {
                    tabData: YardLocalResolver
                },
                canDeactivate: [CanDeactivateViaEditGuardService]
            },
            {
                path: 'data/:tabid',
                component: YardLocalDataComponent,
                data: { tab: 'Yard-Local' },
                resolve: {
                    tabData: YardLocalResolver
                },
                canDeactivate: [CanDeactivateViaEditGuardService]
            }]
    }
];

/**
 * @export
 * @class LocoRoutingModule
 */
@NgModule({
    imports: [
        RouterModule.forChild(yardLocalRoutes)
    ],
    exports: [
        RouterModule
    ]
})
export class YardLocalRoutingModule {

}
